import React from "react";
import LoadingDot from "@core/loading";
import { SequentialLoadingSteps } from "./SequentialLoadingSteps";
import { ThemeColor } from "../../../core/loading/gradient-colors";

interface LoadingContainerProps {
  showSteps?: string[];
  duration?: number;
  title: string;
  fullHeight?: boolean;
  themeColor: ThemeColor;
  onLastStepNearCompletion?: () => void;
}

const LoadingContainer: React.FC<LoadingContainerProps> = ({
  showSteps,
  duration = 40,
  title,
  themeColor = "blue",
  fullHeight = true,
  onLastStepNearCompletion,
}) => {
  if (!showSteps) {
    return (
      <LoadingDot
        title={title}
        themeColor={themeColor}
        fullHeight={fullHeight}
      />
    );
  }

  return (
    <SequentialLoadingSteps
      steps={showSteps}
      themeColor={themeColor}
      duration={duration}
      onLastStepNearCompletion={onLastStepNearCompletion}
    />
  );
};

export default LoadingContainer;
